import request from '@/utils/request'

export function login (val) {
  return request({
    url: '/api/crm/oauth/token', // 接口
    method: 'post', // 请求方式
    data: val, // 数据
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 用户重置密码
export function resetPwd (val) {
  return request({
    url: '/api/crm/user/resetPwd', // 接口
    method: 'post', // 请求方式
    data: val // 数据
  })
}

// 快捷登录
export function authenticationMobile (val) {
  return request({
    url: '/api/crm/authentication/mobile', // 接口
    method: 'post', // 请求方式
    data: val, // 数据
    transformRequest: [function (data) {
      // Do whatever you want to transform the data
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      ret = ret.slice(0, ret.length - 1)
      return ret
    }]
  })
}
